import * as React from "react";
import { UserDetails } from "../../../models/UserDetails";
import { PasswordToggleInput } from "../../PasswordToggleInput";
import { SilModal, SilModalProps } from "../../SilModal";
import { InputField, ValidatedField } from "../shared/forms";

interface Props extends SilModalProps {
  user: UserDetails;
  submit: (newPassword: string) => void;
}

interface State {
  password: ValidatedField<string>;
  wasValidated: boolean;
}

export class PasswordModal extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      wasValidated: false,
      password: { value: '', isValid: true, message: '' }
    };
  }

  onChangeValidated = (e: any) => {
    const state = {
      ...this.state,
      [e.target.name]: {
        ...this.state[e.target.name],
        value: e.target.value
      }
    }

    this.setState(state);
  }

  onSubmit = (e: any) => {
    e.preventDefault();
    this.resetValidationStates();
    if (this.formIsValid()) {
      this.props.submit(this.state.password.value);
    }
  }

  formIsValid = () => {
    const password = { ...this.state.password };

    let isValid = true;
    if (password.value == null || password.value == '') {
      password.isValid = false;
      password.message = `* Enter ${this.props.user.userName}'s new password`;
      isValid = false;
    }

    if (!isValid) {
      this.setState({
        password
      })
    }

    this.setState({
      wasValidated: true
    });

    return isValid;
  }

  resetValidationStates = () => {
    const state = JSON.parse(JSON.stringify(this.state));
    Object.keys(state).map(key => {
      if (state[key].hasOwnProperty('isValid')) {
        state[key].isValid = true;
        state[key].message = '';
      }
    })
    this.setState(state);
  }

  render() {
    return (
      <SilModal {... this.props} title={`Set ${this.props.user.userName}'s password`}>
        <form>
          <div className="form-group row">
            <label className="col-sm-2 col-form-label">Password</label>
            <div className="col-sm-10">
              <PasswordToggleInput
                name="password"
                className={`form-control ${!this.state.password.isValid ? 'is-invalid' : null}`}
                value={this.state.password.value}
                onChange={this.onChangeValidated}
                placeholder="New password"
                autoFocus={true}
                feedbackMessage={this.state.password.message}
              />
            </div>
          </div>
          <button
            className="btn btn-default"
            onClick={this.props.closeModal}>
            Cancel
          </button>
          <button
            className="btn btn-success"
            onClick={e => this.onSubmit(e)}>
            Save password
          </button>
        </form>
      </SilModal>
    );
  }
}
